/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Reformulation_AcceptInputs */

const en_keyword_optimizer_reformulation_accept = /** @type {(inputs: Keyword_Optimizer_Reformulation_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept`)
};

const de_keyword_optimizer_reformulation_accept = /** @type {(inputs: Keyword_Optimizer_Reformulation_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akzeptieren`)
};

const fr_keyword_optimizer_reformulation_accept = /** @type {(inputs: Keyword_Optimizer_Reformulation_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepter`)
};

const es_keyword_optimizer_reformulation_accept = /** @type {(inputs: Keyword_Optimizer_Reformulation_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceptar`)
};

const it_keyword_optimizer_reformulation_accept = /** @type {(inputs: Keyword_Optimizer_Reformulation_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accetta`)
};

const nl_keyword_optimizer_reformulation_accept = /** @type {(inputs: Keyword_Optimizer_Reformulation_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepteren`)
};

const pl_keyword_optimizer_reformulation_accept = /** @type {(inputs: Keyword_Optimizer_Reformulation_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akceptuj`)
};

const fi_keyword_optimizer_reformulation_accept = /** @type {(inputs: Keyword_Optimizer_Reformulation_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hyväksy`)
};

const da_keyword_optimizer_reformulation_accept = /** @type {(inputs: Keyword_Optimizer_Reformulation_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceptér`)
};

const sv_keyword_optimizer_reformulation_accept = /** @type {(inputs: Keyword_Optimizer_Reformulation_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Godkänn`)
};

/**
* | output |
* | --- |
* | "Accept" |
*
* @param {Keyword_Optimizer_Reformulation_AcceptInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_reformulation_accept = /** @type {((inputs?: Keyword_Optimizer_Reformulation_AcceptInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Reformulation_AcceptInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_reformulation_accept(inputs)
	if (locale === "fr") return fr_keyword_optimizer_reformulation_accept(inputs)
	if (locale === "es") return es_keyword_optimizer_reformulation_accept(inputs)
	if (locale === "it") return it_keyword_optimizer_reformulation_accept(inputs)
	if (locale === "nl") return nl_keyword_optimizer_reformulation_accept(inputs)
	if (locale === "pl") return pl_keyword_optimizer_reformulation_accept(inputs)
	if (locale === "fi") return fi_keyword_optimizer_reformulation_accept(inputs)
	if (locale === "da") return da_keyword_optimizer_reformulation_accept(inputs)
	if (locale === "sv") return sv_keyword_optimizer_reformulation_accept(inputs)
	return en_keyword_optimizer_reformulation_accept(inputs)
});